import { BaseError, createErrorBuilder, } from '@wix/public-editor-platform-errors';
export var DesignPresetsErrorCode;
(function (DesignPresetsErrorCode) {
    DesignPresetsErrorCode["UnknownDesignPreset"] = "UnknownDesignPreset";
})(DesignPresetsErrorCode || (DesignPresetsErrorCode = {}));
class DesignPresetsError extends BaseError {
    constructor(message, code) {
        super(message, code, 'DesignPresets Private API Error');
    }
    withPreset(preset) {
        this.state.preset = preset;
        return this;
    }
    withAvailablePresets(presets) {
        this.state.presets = presets.join(' / ');
        return this;
    }
}
export const createDesignPresetsError = createErrorBuilder(DesignPresetsError);
//# sourceMappingURL=errors.js.map